import { defineAsyncComponent } from 'vue'
export default {
  characteristic: defineAsyncComponent(() => import("/var/www/html/integrado/layouts/characteristic.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/html/integrado/layouts/default.vue").then(m => m.default || m)),
  "layout-asesor": defineAsyncComponent(() => import("/var/www/html/integrado/layouts/layoutAsesor.vue").then(m => m.default || m))
}